import dynamic from 'next/dynamic';
import type { PageLocaleSelectProps } from '@/containers/PageLayout/components/PageLocaleSelect/PageLocaleSelect';

export const PageLocaleSelect = dynamic<PageLocaleSelectProps>(() =>
  import('./PageLocaleSelect').then(mod => mod.PageLocaleSelectComponent)
);
